import { Box, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleAbstract = ({ abstracts }: { abstracts: any }) => {
  if (!abstracts) {
    return null;
  }

  return (
    <Box>
      <Typography component="h2">
        <SpanTypography sx={{
          fontSize: HEADING_SIZE.section
        }}>Abstract</SpanTypography>
      </Typography>
      <Box>
        {abstracts.map((section: any, sectionIndex: number) =>
          section.title && section.title !== "" ? (
            <Box component="article" key={`abstract-section-${sectionIndex}`}>
              {section.content.map((paragraph: string, index: number) => (
                <Box
                  key={index}
                  sx={{
                    mb: 0.5,
                    textIndent: "1.5rem"
                  }}>
                  {index === 0 && section.title.trim().length > 0 && (
                    <Typography
                      variant="h4"
                      component="h3"
                      sx={{
                        display: "inline",
                        fontSize: HEADING_SIZE.subsection,
                        mr: 0.25
                      }}>
                      {section.title}
                      {/:$/.test(section.title) ? "" : ":"}
                    </Typography>
                  )}
                  {section.content.length > 0 && (
                    <Typography
                      variant="body1"
                      sx={{
                        display: "inline",
                        fontSize: "1rem"
                      }}>
                      {ReactHtmlParser(paragraph)}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>
          ) : (
            <Box key={`abstract-section-${sectionIndex}`}>
              {section.content.map(
                (content: string, index: number) =>
                  content.length > 0 && (
                    <Typography
                      key={index}
                      sx={{
                        fontSize: "1rem",
                        textIndent: "1.5rem"
                      }}>
                      {ReactHtmlParser(content)}
                    </Typography>
                  ),
              )}
            </Box>
          ),
        )}
      </Box>
    </Box>
  );
};

export default ArticleAbstract;
